/**
 * SentimentBadge - Color-coded badge for all sentiment levels
 */

import React from 'react';

const SENTIMENT_CONFIG = {
  very_positive: { classes: 'bg-green-700 text-white', label: 'Very Positive' },
  positive:      { classes: 'bg-green-100 text-green-800', label: 'Positive' },
  neutral:       { classes: 'bg-gray-100 text-gray-700', label: 'Neutral' },
  negative:      { classes: 'bg-red-100 text-red-800', label: 'Negative' },
  very_negative: { classes: 'bg-red-600 text-white', label: 'Very Negative' },
  mixed:         { classes: 'bg-yellow-100 text-yellow-800', label: 'Mixed' },
};

const SentimentBadge = ({ sentiment = 'neutral' }) => {
  const config = SENTIMENT_CONFIG[sentiment] || SENTIMENT_CONFIG.neutral;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.classes}`}>
      {config.label}
    </span>
  );
};

export default React.memo(SentimentBadge);
